import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const SUPPORTED_LANGUAGES = ['en', 'ar', 'hi', 'fr'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const RTL_LANGUAGES = new Set<string>(['ar']);

function applyDocumentLanguage(lng: string) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.setAttribute('lang', lng);
  root.setAttribute('dir', RTL_LANGUAGES.has(lng) ? 'rtl' : 'ltr');
}

export const NAMESPACES = [
  'common',
  'auth',
  'layout',
  'dashboard',
  'dids',
  'agents',
  'schemas',
  'verifications',
  'marketplace',
  'zk',
  'trust',
  'docs',
  'issuer',
  'verifier',
  'audit',
  'respond',
  'adjudicator',
] as const;

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    ns: NAMESPACES as unknown as string[],
    defaultNS: 'common',
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ida.lang',
    },
    react: {
      useSuspense: true,
    },
  });

i18n.on('languageChanged', (lng) => applyDocumentLanguage(lng));
applyDocumentLanguage(i18n.resolvedLanguage ?? i18n.language ?? 'en');

export default i18n;
